// Test IDs for the profile / collaborators / account-switcher feature (Epic 10).
// Keys camelCase, values kebab-case `<feature>-<element>` — see ./auth.js.

export const PROFILE = {
	page: 'profile-page',
	nameInput: 'profile-name-input',
	nameEdit: 'profile-name-edit',
	nameSave: 'profile-name-save',
	nameCancel: 'profile-name-cancel',
	emailValue: 'profile-email-value',
	planBadge: 'profile-plan-badge',
	adminLink: 'profile-admin-link',
	pwCurrent: 'profile-pw-current',
	pwNew: 'profile-pw-new',
	pwConfirm: 'profile-pw-confirm',
	pwSubmit: 'profile-pw-submit',
	logoutAll: 'profile-logout-all',
	personaResetSection: 'profile-persona-reset-section',
	personaResetTrigger: 'profile-persona-reset-trigger',
	personaResetContinue: 'profile-persona-reset-continue',
	personaResetCancel: 'profile-persona-reset-cancel',
	personaResetInput: 'profile-persona-reset-input',
	personaResetConfirm: 'profile-persona-reset-confirm',
};

export const COLLAB = {
	section: 'collab-section',
	counter: 'collab-counter',
	inviteInput: 'collab-invite-input',
	inviteSubmit: 'collab-invite-submit',
	inviteFeedback: 'collab-invite-feedback',
	list: 'collab-list',
	empty: 'collab-empty',
	loading: 'collab-loading',
	error: 'collab-error',
	full: 'collab-full',
	item: 'collab-item', // suffixed with -<id>
	resend: 'collab-resend', // suffixed with -<id>
	resendConfirm: 'collab-resend-confirm', // suffixed with -<id>
	revoke: 'collab-revoke', // suffixed with -<id>
	revokeConfirm1: 'collab-revoke-confirm-1', // suffixed with -<id>
	revokeConfirm2: 'collab-revoke-confirm-2', // suffixed with -<id>
};

export const INVITES = {
	section: 'invites-section',
	item: 'invites-item', // suffixed with -<id>
	accept: 'invites-accept', // suffixed with -<id>
	decline: 'invites-decline', // suffixed with -<id>
};

export const SWITCHER = {
	root: 'account-switcher',
	trigger: 'account-switcher-trigger',
	option: 'account-switcher-option', // suffixed with -own | -<ownerId>
	banner: 'viewer-banner',
	bannerExit: 'viewer-banner-exit',
	pendingDot: 'account-pending-dot',
};
